import classnames from 'classnames';

import styles from './TableRow.module.scss';

interface TableRowProps {
  highlight?: boolean;
  children: React.ReactNode | React.ReactNode[];
}

export const TableRow: React.FC<TableRowProps> = ({
  children,
  highlight = false,
}) => (
  <tr
    data-testid={highlight && 'selected'}
    className={classnames(styles.root, {
      [styles.highlight]: highlight,
    })}
  >
    {children}
  </tr>
);
